



// import React, { useState, useEffect } from 'react';

// import { ref, onValue, query, orderByChild, equalTo } from 'firebase/database';
// import { database } from '../firebase';
// import { Calendar, momentLocalizer } from 'react-big-calendar';
// import moment from 'moment';
// import 'react-big-calendar/lib/css/react-big-calendar.css';
// import Header from './Header';
// import Footer from './Footer';

// const localizer = momentLocalizer(moment);

// const SchoolInformationPage = () => {
//   const [classes, setClasses] = useState([]);
//   const [selectedClass, setSelectedClass] = useState('');
//   const [yearlyPlans, setYearlyPlans] = useState([]);
//   const [syllabus, setSyllabus] = useState([]);
//   const [examTimetables, setExamTimetables] = useState([]);
//   const [events, setEvents] = useState([]);
//   const [activeTab, setActiveTab] = useState('calendar');
//   const [calendarView, setCalendarView] = useState('month');
//   const [currentDate, setCurrentDate] = useState(new Date());
//   const [expandedTerm, setExpandedTerm] = useState(null);
//   const [mobileNumber, setMobileNumber] = useState('');
//   const [parentData, setParentData] = useState(null);
//   const [mobileVerified, setMobileVerified] = useState(false);
//   const [isLoading, setIsLoading] = useState(false);
//   const [error, setError] = useState('');

//   // Fetch all classes
//   useEffect(() => {
//     const classesRef = ref(database, 'school/classes');
//     onValue(classesRef, (snapshot) => {
//       const data = snapshot.val();
//       if (data) {
//         const classesArray = Object.entries(data).map(([id, classData]) => ({
//           id,
//           ...classData
//         }));
//         setClasses(classesArray);
//       }
//     });
//   }, []);

//   // Fetch academic data when class is selected
//   useEffect(() => {
//     if (selectedClass && mobileVerified) {
//       const plansRef = ref(database, `school/academic/${selectedClass}/yearlyPlans`);
//       onValue(plansRef, (snapshot) => {
//         const data = snapshot.val();
//         if (data) {
//           const plansArray = Object.entries(data).map(([id, planData]) => ({
//             id,
//             ...planData,
//             structure: planData.structure ? JSON.parse(planData.structure) : []
//           }));
//           setYearlyPlans(plansArray);
//         } else {
//           setYearlyPlans([]);
//         }
//       }, (error) => {
//         console.error("Error fetching yearly plans:", error);
//         setYearlyPlans([]);
//       });

//       const syllabiRef = ref(database, `school/academic/${selectedClass}/syllabus`);
//       onValue(syllabiRef, (snapshot) => {
//         const data = snapshot.val();
//         setSyllabus(data ? Object.values(data) : []);
//       });

//       const timetablesRef = ref(database, `school/academic/${selectedClass}/examTimetables`);
//       onValue(timetablesRef, (snapshot) => {
//         const data = snapshot.val();
//         setExamTimetables(data ? Object.values(data) : []);
//       });
//     }
//   }, [selectedClass, mobileVerified]);

//   // Fetch calendar events
//   useEffect(() => {
//     const eventsRef = ref(database, 'school/academic/calendar');
//     onValue(eventsRef, (snapshot) => {
//       const data = snapshot.val();
//       if (data) {
//         const eventsArray = Object.entries(data).map(([id, event]) => ({
//           id,
//           ...event,
//           start: new Date(event.start),
//           end: new Date(event.end)
//         }));
//         setEvents(eventsArray);
//       }
//     });
//   }, []);

//   // Verify mobile number
//   const verifyMobile = async (e) => {
//     e.preventDefault();
//     if (mobileNumber.length !== 10) {
//       setError('Please enter a valid 10-digit mobile number');
//       return;
//     }

//     setIsLoading(true);
//     setError('');

//     try {
//       const parentsRef = ref(database, 'school/parents');
//       const queryRef = query(parentsRef, orderByChild('mobile'), equalTo(mobileNumber));
      
//       onValue(queryRef, (snapshot) => {
//         const data = snapshot.val();
//         if (data) {
//           const parentKey = Object.keys(data)[0];
//           setParentData({ id: parentKey, ...data[parentKey] });
//           setMobileVerified(true);
//         } else {
//           setError('No data found for this mobile number. Please contact the school administration.');
//         }
//         setIsLoading(false);
//       }, {
//         onlyOnce: true
//       });
//     } catch (err) {
//       console.error("Error verifying mobile:", err);
//       setError('Failed to verify mobile number. Please try again.');
//       setIsLoading(false);
//     }
//   };

//   // Event style based on type
//   const eventStyleGetter = (event) => {
//     let backgroundColor = '#3174ad';
//     if (event.type === 'holiday') backgroundColor = '#d32f2f';
//     if (event.type === 'exam') backgroundColor = '#ff8f00';
//     if (event.type === 'event') backgroundColor = '#388e3c';

//     return {
//       style: {
//         backgroundColor,
//         borderRadius: '4px',
//         opacity: 0.8,
//         color: 'white',
//         border: '0px',
//         display: 'block'
//       }
//     };
//   };

//   // Parse yearly plan data into terms and months
//   const parseYearlyPlan = (plan) => {
//     if (!plan) return [];
    
//     if (Array.isArray(plan.structure)) {
//       return plan.structure;
//     }
    
//     if (typeof plan.structure === 'string') {
//       try {
//         return JSON.parse(plan.structure);
//       } catch (e) {
//         console.error("Error parsing yearly plan structure:", e);
//         return [];
//       }
//     }
    
//     return [];
//   };

//   // Styles
//   const containerStyle = {
//     minHeight: '100vh',
//     backgroundColor: '#f8fafc',
//     fontFamily: "'Inter', sans-serif",
//     display: 'flex',
//     flexDirection: 'column',
//     // justifyContent:'space-between'
//   };

//   const headerStyle = {
//     background: 'linear-gradient(135deg, #1e3a8a 0%, #1e40af 100%)',
//     color: 'white',
//     padding: '2rem 2rem',
//     textAlign: 'center'
//   };

//   const contentStyle = {
//     maxWidth: '1200px',
//     margin: '0 auto',
//     padding: '2rem 0.9rem'
//   };

//   const tabStyle = {
//     display: 'flex',
//     borderBottom: '1px solid #e2e8f0',
//     marginBottom: '1.5rem',
//     flexWrap: 'wrap'
//   };

//   const tabButtonStyle = (isActive) => ({
//     padding: '0.75rem 1.5rem',
//     backgroundColor: isActive ? '#1e40af' : 'transparent',
//     color: isActive ? 'white' : '#1e40af',
//     border: 'none',
//     cursor: 'pointer',
//     fontSize: '0.875rem',
//     fontWeight: '500',
//     borderRadius: '8px 8px 0 0',
//     marginRight: '0.5rem',
//     marginBottom: '0.5rem'
//   });

//   const cardStyle = {
//     backgroundColor: 'white',
//     borderRadius: '12px',
//     boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
//     padding: '1.4rem',
//     marginBottom: '1.5rem'
//   };

//   const fileItemStyle = {
//     display: 'flex',
//     alignItems: 'center',
//     padding: '0.75rem',
//     borderBottom: '1px solid #e2e8f0',
//     ':last-child': {
//       borderBottom: 'none'
//     }
//   };

//   const termCardStyle = {
//     backgroundColor: '#ffffff',
//     borderRadius: '8px',
//     boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
//     marginBottom: '1rem',
//     overflow: 'hidden'
//   };

//   const termHeaderStyle = {
//     backgroundColor: '#1e40af',
//     color: 'white',
//     padding: '0.75rem 1rem',
//     display: 'flex',
//     justifyContent: 'space-between',
//     alignItems: 'center',
//     cursor: 'pointer'
//   };

//   const monthCardStyle = {
//     backgroundColor: '#f8fafc',
//     padding: '0.75rem 1rem',
//     borderBottom: '1px solid #e2e8f0',
//     ':last-child': {
//       borderBottom: 'none'
//     }
//   };

//   const weekStyle = {
//     display: 'flex',
//     padding: '0.5rem 0',
//     borderBottom: '1px dashed #e2e8f0',
//     ':last-child': {
//       borderBottom: 'none'
//     }
//   };

//   const dayStyle = {
//     flex: 1,
//     padding: '0.25rem',
//     textAlign: 'center'
//   };

//   const inputStyle = {
//     width: '100%',
//     padding: '0.75rem 1rem',
//     borderRadius: '8px',
//     border: '1px solid #e2e8f0',
//     fontSize: '1rem',
//     outline: 'none',
//     marginBottom: '1rem'
//   };

//   const buttonStyle = {
//     backgroundColor: '#3b82f6',
//     color: 'white',
//     padding: '0.75rem 1.5rem',
//     border: 'none',
//     borderRadius: '8px',
//     cursor: 'pointer',
//     fontSize: '1rem',
//     fontWeight: '500',
//     width: '100%'
//   };

//   return (
//     <>
//     <Header/>
//     <div style={containerStyle}>
//       <header style={headerStyle}>
//         <h1 style={{ fontSize: '2rem', fontWeight: '700', margin: 0 }}>School Information Portal</h1>
//         <p style={{ margin: '0.5rem 0 0', opacity: 0.9, fontSize: '1rem' }}>
//           Academic calendar, syllabus, and resources
//         </p>
//       </header>

//       <main style={contentStyle}>
//         {!mobileVerified ? (
//           <div style={{
//   backgroundColor: 'white',
//   borderRadius: '16px',
//   boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
//   padding: '2.5rem',
//   maxWidth: '450px',
//   margin: '0 auto',
//   background: 'linear-gradient(to bottom right, #ffffff, #f9fafb)',
//   border: '1px solid rgba(255, 255, 255, 0.3)',
//   position: 'relative',
//   overflow: 'hidden'
// }}>
//   {/* Decorative elements */}
//   <div style={{
//     position: 'absolute',
//     top: '-50px',
//     right: '-50px',
//     width: '200px',
//     height: '200px',
//     borderRadius: '50%',
//     background: 'radial-gradient(circle, rgba(59, 130, 246, 0.1) 0%, rgba(59, 130, 246, 0) 70%)',
//     zIndex: 0
//   }}></div>
//   <div style={{
//     position: 'absolute',
//     bottom: '-30px',
//     left: '-30px',
//     width: '150px',
//     height: '150px',
//     borderRadius: '50%',
//     background: 'radial-gradient(circle, rgba(16, 185, 129, 0.1) 0%, rgba(16, 185, 129, 0) 70%)',
//     zIndex: 0
//   }}></div>

//   {/* Content */}
//   <div style={{ position: 'relative', zIndex: 1 }}>
//     <div style={{
//       display: 'flex',
//       justifyContent: 'center',
//       marginBottom: '1.5rem'
//     }}>
//       <div style={{
//         backgroundColor: '#3b82f6',
//         width: '60px',
//         height: '60px',
//         borderRadius: '50%',
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'center',
//         boxShadow: '0 4px 6px -1px rgba(59, 130, 246, 0.3), 0 2px 4px -1px rgba(59, 130, 246, 0.1)'
//       }}>
//         <svg 
//           xmlns="http://www.w3.org/2000/svg" 
//           width="28" 
//           height="28" 
//           viewBox="0 0 24 24" 
//           fill="none" 
//           stroke="white" 
//           strokeWidth="2" 
//           strokeLinecap="round" 
//           strokeLinejoin="round"
//         >
//           <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
//         </svg>
//       </div>
//     </div>

//     <h2 style={{ 
//       fontSize: '1.75rem', 
//       fontWeight: '700', 
//       marginBottom: '1rem', 
//       textAlign: 'center',
//       color: '#1e293b',
//       background: 'linear-gradient(to right, #3b82f6, #10b981)',
//       WebkitBackgroundClip: 'text',
//       WebkitTextFillColor: 'transparent'
//     }}>
//      Access Academic Data
//     </h2>
    
//     <p style={{ 
//       color: '#64748b', 
//       textAlign: 'center', 
//       marginBottom: '2rem',
//       fontSize: '0.95rem',
//       lineHeight: '1.5'
//     }}>
//       Enter your registered mobile number to access your child's academic information
//     </p>

//     <form onSubmit={verifyMobile}>
//       <div style={{ marginBottom: '1.5rem' }}>
//         <div style={{
//           display: 'flex',
//           alignItems: 'center',
//           backgroundColor: '#f8fafc',
//           borderRadius: '12px',
//           padding: '0 1rem',
//           border: '1px solid #e2e8f0',
//           transition: 'all 0.3s ease',
//           ':focus-within': {
//             borderColor: '#3b82f6',
//             boxShadow: '0 0 0 3px rgba(59, 130, 246, 0.2)'
//           }
//         }}>
//           <span style={{
//             color: '#64748b',
//             marginRight: '0.5rem',
//             fontWeight: '500'
//           }}>+91</span>
//           <input
//             type="tel"
//             id="mobile"
//             value={mobileNumber}
//             onChange={(e) => setMobileNumber(e.target.value.replace(/\D/g, ''))}
//             placeholder="Enter 10-digit mobile number"
//             maxLength="10"
//             style={{
//               flex: 1,
//               padding: '0.875rem 0',
//               border: 'none',
//               outline: 'none',
//               backgroundColor: 'transparent',
//               fontSize: '1rem',
//               color: '#1e293b'
//             }}
//             required
//           />
//         </div>
//       </div>

//       <button 
//         type="submit" 
//         style={{
//           width: '100%',
//           padding: '0.875rem',
//           backgroundColor: '#3b82f6',
//           color: 'white',
//           border: 'none',
//           borderRadius: '12px',
//           fontSize: '1rem',
//           fontWeight: '600',
//           cursor: 'pointer',
//           transition: 'all 0.3s ease',
//           boxShadow: '0 4px 6px -1px rgba(59, 130, 246, 0.3), 0 2px 4px -1px rgba(59, 130, 246, 0.1)',
//           ':hover': {
//             backgroundColor: '#2563eb',
//             transform: 'translateY(-1px)'
//           },
//           ':active': {
//             transform: 'translateY(0)'
//           },
//           ':disabled': {
//             opacity: 0.7,
//             cursor: 'not-allowed',
//             transform: 'none'
//           }
//         }}
//         disabled={isLoading}
//       >
//         {isLoading ? (
//           <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
//             <svg 
//               style={{ 
//                 animation: 'spin 1s linear infinite',
//                 marginRight: '0.5rem',
//                 width: '1.25rem',
//                 height: '1.25rem'
//               }} 
//               xmlns="http://www.w3.org/2000/svg" 
//               fill="none" 
//               viewBox="0 0 24 24"
//             >
//               <circle style={{ opacity: 0.25 }} cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
//               <path style={{ opacity: 0.75 }} fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
//             </svg>
//             Verifying...
//           </div>
//         ) : (
//           'Continue to Portal'
//         )}
//       </button>

//       {error && (
//         <div style={{
//           marginTop: '1.25rem',
//           padding: '0.875rem',
//           backgroundColor: '#fee2e2',
//           color: '#b91c1c',
//           borderRadius: '8px',
//           textAlign: 'center',
//           fontSize: '0.875rem',
//           display: 'flex',
//           alignItems: 'center',
//           justifyContent: 'center'
//         }}>
//           <svg 
//             xmlns="http://www.w3.org/2000/svg" 
//             width="16" 
//             height="16" 
//             viewBox="0 0 24 24" 
//             fill="none" 
//             stroke="currentColor" 
//             strokeWidth="2" 
//             strokeLinecap="round" 
//             strokeLinejoin="round"
//             style={{ marginRight: '0.5rem' }}
//           >
//             <circle cx="12" cy="12" r="10"></circle>
//             <line x1="12" y1="8" x2="12" y2="12"></line>
//             <line x1="12" y1="16" x2="12.01" y2="16"></line>
//           </svg>
//           {error}
//         </div>
//       )}
//     </form>
//   </div>
// </div>
//         ) : (
//           <>
//             <div style={cardStyle}>
//               <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//                 <div>
//                   <h2 style={{ fontSize: '1.25rem', fontWeight: '600', marginBottom: '0.25rem' }}>
//                     Welcome, {parentData?.name || 'Parent'}
//                   </h2>
//                   <p style={{ color: '#64748b' }}>Mobile: {parentData?.mobile}</p>
//                 </div>
//                 <button
//                   onClick={() => {
//                     setMobileVerified(false);
//                     setMobileNumber('');
//                     setParentData(null);
//                     setSelectedClass('');
//                   }}
//                   style={{
//                     backgroundColor: '#ef4444',
//                     color: 'white',
//                     padding: '0.5rem 1rem',
//                     border: 'none',
//                     borderRadius: '8px',
//                     cursor: 'pointer'
//                   }}
//                 >
//                   Logout
//                 </button>
//               </div>
//             </div>

//             <div style={cardStyle}>
//               <h2 style={{ fontSize: '1.25rem', fontWeight: '600', marginBottom: '1rem' }}>Select Your Class</h2>
//               <select
//                 style={inputStyle}
//                 value={selectedClass}
//                 onChange={(e) => setSelectedClass(e.target.value)}
//               >
//                 <option value="">Select a class...</option>
//                 {classes.map(cls => (
//                   <option key={cls.id} value={cls.id}>{cls.name}</option>
//                 ))}
//               </select>
//             </div>

//             <div style={tabStyle}>
//               <button 
//                 style={tabButtonStyle(activeTab === 'calendar')}
//                 onClick={() => setActiveTab('calendar')}
//               >
//                 School Calendar
//               </button>
//               {selectedClass && (
//                 <>
//                   <button 
//                     style={tabButtonStyle(activeTab === 'yearlyPlan')}
//                     onClick={() => setActiveTab('yearlyPlan')}
//                   >
//                     Yearly Plan
//                   </button>
//                   <button 
//                     style={tabButtonStyle(activeTab === 'academic')}
//                     onClick={() => setActiveTab('academic')}
//                   >
//                     Academic Resources
//                   </button>
//                   <button 
//                     style={tabButtonStyle(activeTab === 'exams')}
//                     onClick={() => setActiveTab('exams')}
//                   >
//                     Exam Information
//                   </button>
//                 </>
//               )}
//             </div>

//             {activeTab === 'calendar' && (
//               <div>
//                 <div style={cardStyle}>
//                   <h2 style={{ fontSize: '1.25rem', fontWeight: '600', marginBottom: '1rem' }}>School Calendar</h2>
//                   <div style={{ height: '600px' }}>
//                     <Calendar
//                       localizer={localizer}
//                       events={events}
//                       startAccessor="start"
//                       endAccessor="end"
//                       style={{ height: '100%' }}
//                       eventPropGetter={eventStyleGetter}
//                       views={['month', 'week', 'day', 'agenda']}
//                       view={calendarView}
//                       onView={setCalendarView}
//                       date={currentDate}
//                       onNavigate={setCurrentDate}
//                       components={{
//                         event: ({ event }) => (
//                           <div style={{ padding: '0.25rem' }}>
//                             <strong>{event.title}</strong>
//                             {event.description && (
//                               <p style={{ fontSize: '0.75rem', marginTop: '0.25rem' }}>{event.description}</p>
//                             )}
//                           </div>
//                         )
//                       }}
//                     />
//                   </div>
//                 </div>

//                 <div style={cardStyle}>
//                   <h2 style={{ fontSize: '1.25rem', fontWeight: '600', marginBottom: '1rem' }}>Upcoming Events</h2>
//                   {events
//                     .filter(event => new Date(event.end) > new Date())
//                     .sort((a, b) => new Date(a.start) - new Date(b.start))
//                     .slice(0, 5)
//                     .map(event => (
//                       <div key={event.id} style={{ 
//                         padding: '1rem', 
//                         marginBottom: '0.75rem', 
//                         borderRadius: '8px', 
//                         backgroundColor: '#f8fafc',
//                         borderLeft: `4px solid ${
//                           event.type === 'holiday' ? '#d32f2f' : 
//                           event.type === 'exam' ? '#ff8f00' : 
//                           '#388e3c'
//                         }`
//                       }}>
//                         <div style={{ display: 'flex', justifyContent: 'space-between' }}>
//                           <div>
//                             <h3 style={{ fontSize: '1rem', fontWeight: '600', margin: 0 }}>{event.title}</h3>
//                             <p style={{ fontSize: '0.875rem', color: '#64748b', marginTop: '0.25rem' }}>
//                               {moment(event.start).format('MMMM D, YYYY h:mm A')} - {moment(event.end).format('MMMM D, YYYY h:mm A')}
//                             </p>
//                           </div>
//                           <span style={{
//                             padding: '0.25rem 0.5rem',
//                             borderRadius: '9999px',
//                             backgroundColor: event.type === 'holiday' ? '#fee2e2' : event.type === 'exam' ? '#ffedd5' : '#dcfce7',
//                             color: event.type === 'holiday' ? '#b91c1c' : event.type === 'exam' ? '#9a3412' : '#166534',
//                             fontSize: '0.75rem',
//                             fontWeight: '600'
//                           }}>
//                             {event.type === 'holiday' ? 'Holiday' : event.type === 'exam' ? 'Exam' : 'Event'}
//                           </span>
//                         </div>
//                         {event.description && (
//                           <p style={{ fontSize: '0.875rem', marginTop: '0.5rem' }}>{event.description}</p>
//                         )}
//                       </div>
//                     ))
//                   }
//                   {events.filter(event => new Date(event.end) > new Date()).length === 0 && (
//                     <p style={{ textAlign: 'center', color: '#64748b' }}>No upcoming events scheduled</p>
//                   )}
//                 </div>
//               </div>
//             )}

//             {activeTab === 'yearlyPlan' && selectedClass && (
//               <div>
//                 <div style={cardStyle}>
//                   <h2 style={{ fontSize: '1.25rem', fontWeight: '600', marginBottom: '1rem' }}>Yearly Academic Plans</h2>
//                   {yearlyPlans.length > 0 ? (
//                     yearlyPlans.map((plan, index) => (
//                       <div key={index} style={fileItemStyle}>
//                         <svg style={{ width: '1.5rem', height: '1.5rem', color: '#3b82f6', marginRight: '1rem' }} fill="currentColor" viewBox="0 0 20 20">
//                           <path fillRule="evenodd" d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm2 6a1 1 0 011-1h6a1 1 0 110 2H7a1 1 0 01-1-1zm1 3a1 1 0 100 2h6a1 1 0 100-2H7z" clipRule="evenodd" />
//                         </svg>
//                         <div style={{ flex: 1 }}>
//                           <div style={{ fontWeight: '500' }}>Academic Year {plan.year || 'N/A'}</div>
//                           <div style={{ fontSize: '0.875rem', color: '#64748b' }}>{plan.fileName || 'Yearly Plan Document'}</div>
//                         </div>
//                         {plan.fileUrl ? (
//                           <a 
//                             href={plan.fileUrl} 
//                             target="_blank" 
//                             rel="noopener noreferrer"
//                             style={{
//                               padding: '0.5rem 1rem',
//                               backgroundColor: '#3b82f6',
//                               color: 'white',
//                               borderRadius: '8px',
//                               textDecoration: 'none',
//                               fontSize: '0.875rem',
//                               fontWeight: '500'
//                             }}
//                           >
//                             Download
//                           </a>
//                         ) : (
//                           <span style={{ color: '#64748b', fontSize: '0.875rem' }}>No file available</span>
//                         )}
//                       </div>
//                     ))
//                   ) : (
//                     <p style={{ color: '#64748b' }}>No yearly plans available for this class.</p>
//                   )}
//                 </div>
//               </div>
//             )}

//             {activeTab === 'academic' && selectedClass && (
//               <div>
//                 <div style={cardStyle}>
//                   <h2 style={{ fontSize: '1.25rem', fontWeight: '600', marginBottom: '1rem' }}>Class Syllabus</h2>
//                   {syllabus.length > 0 ? (
//                     syllabus.map((syl, index) => (
//                       <div key={index} style={fileItemStyle}>
//                         <svg style={{ width: '1.5rem', height: '1.5rem', color: '#10b981', marginRight: '1rem' }} fill="currentColor" viewBox="0 0 20 20">
//                           <path d="M9 4.804A7.968 7.968 0 005.5 4c-1.255 0-2.443.29-3.5.804v10A7.969 7.969 0 015.5 14c1.669 0 3.218.51 4.5 1.385A7.962 7.962 0 0114.5 14c1.255 0 2.443.29 3.5.804v-10A7.968 7.968 0 0014.5 4c-1.255 0-2.443.29-3.5.804V12a1 1 0 11-2 0V4.804z" />
//                         </svg>
//                         <div style={{ flex: 1 }}>
//                           <div style={{ fontWeight: '500' }}>{syl.fileName}</div>
//                           <div style={{ fontSize: '0.875rem', color: '#64748b' }}>
//                             Uploaded on {moment(syl.uploadedAt).format('MMMM D, YYYY')}
//                           </div>
//                         </div>
//                         <a 
//                           href={syl.fileUrl} 
//                           target="_blank" 
//                           rel="noopener noreferrer"
//                           style={{
//                             padding: '0.5rem 1rem',
//                             backgroundColor: '#10b981',
//                             color: 'white',
//                             borderRadius: '8px',
//                             textDecoration: 'none',
//                             fontSize: '0.875rem',
//                             fontWeight: '500'
//                           }}
//                         >
//                           Download
//                         </a>
//                       </div>
//                     ))
//                   ) : (
//                     <p style={{ color: '#64748b' }}>No syllabus available for this class.</p>
//                   )}
//                 </div>
//               </div>
//             )}

//             {activeTab === 'exams' && selectedClass && (
//               <div>
//                 <div style={cardStyle}>
//                   <h2 style={{ fontSize: '1.25rem', fontWeight: '600', marginBottom: '1rem' }}>Exam Timetables</h2>
//                   {examTimetables.length > 0 ? (
//                     examTimetables.map((timetable, index) => (
//                       <div key={index} style={fileItemStyle}>
//                         <svg style={{ width: '1.5rem', height: '1.5rem', color: '#7c3aed', marginRight: '1rem' }} fill="currentColor" viewBox="0 0 20 20">
//                           <path fillRule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clipRule="evenodd" />
//                         </svg>
//                         <div style={{ flex: 1 }}>
//                           <div style={{ fontWeight: '500' }}>{timetable.examName || 'Exam Timetable'}</div>
//                           <div style={{ fontSize: '0.875rem', color: '#64748b' }}>{timetable.fileName}</div>
//                         </div>
//                         <a 
//                           href={timetable.fileUrl} 
//                           target="_blank" 
//                           rel="noopener noreferrer"
//                           style={{
//                             padding: '0.5rem 1rem',
//                             backgroundColor: '#7c3aed',
//                             color: 'white',
//                             borderRadius: '8px',
//                             textDecoration: 'none',
//                             fontSize: '0.875rem',
//                             fontWeight: '500'
//                           }}
//                         >
//                           Download
//                         </a>
//                       </div>
//                     ))
//                   ) : (
//                     <p style={{ color: '#64748b' }}>No exam timetables available for this class.</p>
//                   )}
//                 </div>

//                 {/* <div style={cardStyle}>
//                   <h2 style={{ fontSize: '1.25rem', fontWeight: '600', marginBottom: '1rem' }}>Upcoming Exams</h2>
//                   {events
//                     .filter(event => event.type === 'exam' && new Date(event.end) > new Date())
//                     .sort((a, b) => new Date(a.start) - new Date(b.start))
//                     .map(event => (
//                       <div key={event.id} style={{ 
//                         padding: '1rem', 
//                         marginBottom: '0.75rem', 
//                         borderRadius: '8px', 
//                         backgroundColor: '#ffedd5'
//                       }}>
//                         <div style={{ display: 'flex', justifyContent: 'space-between' }}>
//                           <div>
//                             <h3 style={{ fontSize: '1rem', fontWeight: '600', margin: 0 }}>{event.title}</h3>
//                             <p style={{ fontSize: '0.875rem', color: '#9a3412', marginTop: '0.25rem' }}>
//                               {moment(event.start).format('MMMM D, YYYY h:mm A')}
//                             </p>
//                           </div>
//                         </div>
//                         {event.description && (
//                           <p style={{ fontSize: '0.875rem', marginTop: '0.5rem', color: '#9a3412' }}>
//                             {event.description}
//                           </p>
//                         )}
//                       </div>
//                     ))
//                   }
//                   {events.filter(event => event.type === 'exam' && new Date(event.end) > new Date()).length === 0 && (
//                     <p style={{ color: '#64748b' }}>No upcoming exams scheduled.</p>
//                   )}
//                 </div> */}
//               </div>
//             )}
//           </>
//         )}
//       </main>
//     </div>
//     <Footer/>
//     </>
//   );
// };

// export default SchoolInformationPage;


import React, { useState, useEffect } from 'react';
import { ref, onValue, query, orderByChild, equalTo } from 'firebase/database';
import { database } from '../firebase';
import moment from 'moment';
import Header from './Header';
import Footer from './Footer';

const SchoolInformationPage = () => {
  const [classes, setClasses] = useState([]);
  const [selectedClass, setSelectedClass] = useState('');
  const [yearlyPlans, setYearlyPlans] = useState([]);
  const [syllabus, setSyllabus] = useState([]);
  const [examTimetables, setExamTimetables] = useState([]);
  const [mobileNumber, setMobileNumber] = useState('');
  const [parentData, setParentData] = useState(null);
  const [mobileVerified, setMobileVerified] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  // Fetch all classes
  useEffect(() => {
    const classesRef = ref(database, 'school/classes');
    onValue(classesRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        const classesArray = Object.entries(data).map(([id, classData]) => ({
          id,
          ...classData
        }));
        setClasses(classesArray);
      }
    });
  }, []);

  // Fetch academic data when class is selected
  useEffect(() => {
    if (selectedClass && mobileVerified) {
      const plansRef = ref(database, `school/academic/${selectedClass}/yearlyPlans`);
      onValue(plansRef, (snapshot) => {
        const data = snapshot.val();
        if (data) {
          const plansArray = Object.entries(data).map(([id, planData]) => ({
            id,
            ...planData,
            structure: planData.structure ? JSON.parse(planData.structure) : []
          }));
          setYearlyPlans(plansArray);
        } else {
          setYearlyPlans([]);
        }
      }, (error) => {
        console.error("Error fetching yearly plans:", error);
        setYearlyPlans([]);
      });

      const syllabiRef = ref(database, `school/academic/${selectedClass}/syllabus`);
      onValue(syllabiRef, (snapshot) => {
        const data = snapshot.val();
        setSyllabus(data ? Object.values(data) : []);
      });

      const timetablesRef = ref(database, `school/academic/${selectedClass}/examTimetables`);
      onValue(timetablesRef, (snapshot) => {
        const data = snapshot.val();
        setExamTimetables(data ? Object.values(data) : []);
      });
    }
  }, [selectedClass, mobileVerified]);

  // Verify mobile number
  const verifyMobile = async (e) => {
    e.preventDefault();
    if (mobileNumber.length !== 10) {
      setError('Please enter a valid 10-digit mobile number');
      return;
    }

    setIsLoading(true);
    setError('');

    try {
      const parentsRef = ref(database, 'school/parents');
      const queryRef = query(parentsRef, orderByChild('mobile'), equalTo(mobileNumber));
      
      onValue(queryRef, (snapshot) => {
        const data = snapshot.val();
        if (data) {
          const parentKey = Object.keys(data)[0];
          setParentData({ id: parentKey, ...data[parentKey] });
          setMobileVerified(true);
        } else {
          setError('No data found for this mobile number. Please contact the school administration.');
        }
        setIsLoading(false);
      }, {
        onlyOnce: true
      });
    } catch (err) {
      console.error("Error verifying mobile:", err);
      setError('Failed to verify mobile number. Please try again.');
      setIsLoading(false);
    }
  };

  // Styles
  const containerStyle = {
    minHeight: '100vh',
    backgroundColor: '#f8fafc',
    fontFamily: "'Inter', sans-serif",
    display: 'flex',
    flexDirection: 'column',
  };

  const headerStyle = {
    background: 'linear-gradient(135deg, #1e3a8a 0%, #1e40af 100%)',
    color: 'white',
    padding: '2rem 2rem',
    textAlign: 'center'
  };

  const contentStyle = {
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '2rem 0.9rem'
  };

  const tabStyle = {
    display: 'flex',
    borderBottom: '1px solid #e2e8f0',
    marginBottom: '1.5rem',
    flexWrap: 'wrap'
  };

  const tabButtonStyle = (isActive) => ({
    padding: '0.75rem 1.5rem',
    backgroundColor: isActive ? '#1e40af' : 'transparent',
    color: isActive ? 'white' : '#1e40af',
    border: 'none',
    cursor: 'pointer',
    fontSize: '0.875rem',
    fontWeight: '500',
    borderRadius: '8px 8px 0 0',
    marginRight: '0.5rem',
    marginBottom: '0.5rem'
  });

  const cardStyle = {
    backgroundColor: 'white',
    borderRadius: '12px',
    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
    padding: '1.4rem',
    marginBottom: '1.5rem'
  };

  const fileItemStyle = {
    display: 'flex',
    alignItems: 'center',
    padding: '0.75rem',
    borderBottom: '1px solid #e2e8f0',
    ':last-child': {
      borderBottom: 'none'
    }
  };

  const inputStyle = {
    width: '100%',
    padding: '0.75rem 1rem',
    borderRadius: '8px',
    border: '1px solid #e2e8f0',
    fontSize: '1rem',
    outline: 'none',
    marginBottom: '1rem'
  };

  return (
    <>
      <Header/>
      <div style={containerStyle}>
        <header style={headerStyle}>
          <h1 style={{ fontSize: '2rem', fontWeight: '700', margin: 0 }}>School Information Portal</h1>
          <p style={{ margin: '0.5rem 0 0', opacity: 0.9, fontSize: '1rem' }}>
            Academic syllabus and resources
          </p>
        </header>

        <main style={contentStyle}>
          {!mobileVerified ? (
            <div style={{
              backgroundColor: 'white',
              borderRadius: '16px',
              boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
              padding: '2.5rem',
              maxWidth: '450px',
              margin: '0 auto',
              background: 'linear-gradient(to bottom right, #ffffff, #f9fafb)',
              border: '1px solid rgba(255, 255, 255, 0.3)',
              position: 'relative',
              overflow: 'hidden'
            }}>
              <div style={{
                position: 'absolute',
                top: '-50px',
                right: '-50px',
                width: '200px',
                height: '200px',
                borderRadius: '50%',
                background: 'radial-gradient(circle, rgba(59, 130, 246, 0.1) 0%, rgba(59, 130, 246, 0) 70%)',
                zIndex: 0
              }}></div>
              <div style={{
                position: 'absolute',
                bottom: '-30px',
                left: '-30px',
                width: '150px',
                height: '150px',
                borderRadius: '50%',
                background: 'radial-gradient(circle, rgba(16, 185, 129, 0.1) 0%, rgba(16, 185, 129, 0) 70%)',
                zIndex: 0
              }}></div>

              <div style={{ position: 'relative', zIndex: 1 }}>
                <div style={{
                  display: 'flex',
                  justifyContent: 'center',
                  marginBottom: '1.5rem'
                }}>
                  <div style={{
                    backgroundColor: '#3b82f6',
                    width: '60px',
                    height: '60px',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    boxShadow: '0 4px 6px -1px rgba(59, 130, 246, 0.3), 0 2px 4px -1px rgba(59, 130, 246, 0.1)'
                  }}>
                    <svg 
                      xmlns="http://www.w3.org/2000/svg" 
                      width="28" 
                      height="28" 
                      viewBox="0 0 24 24" 
                      fill="none" 
                      stroke="white" 
                      strokeWidth="2" 
                      strokeLinecap="round" 
                      strokeLinejoin="round"
                    >
                      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
                    </svg>
                  </div>
                </div>

                <h2 style={{ 
                  fontSize: '1.75rem', 
                  fontWeight: '700', 
                  marginBottom: '1rem', 
                  textAlign: 'center',
                  color: '#1e293b',
                  background: 'linear-gradient(to right, #3b82f6, #10b981)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent'
                }}>
                 Access Academic Data
                </h2>
                
                <p style={{ 
                  color: '#64748b', 
                  textAlign: 'center', 
                  marginBottom: '2rem',
                  fontSize: '0.95rem',
                  lineHeight: '1.5'
                }}>
                  Enter your registered mobile number to access your child's academic information
                </p>

                <form onSubmit={verifyMobile}>
                  <div style={{ marginBottom: '1.5rem' }}>
                    <div style={{
                      display: 'flex',
                      alignItems: 'center',
                      backgroundColor: '#f8fafc',
                      borderRadius: '12px',
                      padding: '0 1rem',
                      border: '1px solid #e2e8f0',
                      transition: 'all 0.3s ease',
                      ':focus-within': {
                        borderColor: '#3b82f6',
                        boxShadow: '0 0 0 3px rgba(59, 130, 246, 0.2)'
                      }
                    }}>
                      <span style={{
                        color: '#64748b',
                        marginRight: '0.5rem',
                        fontWeight: '500'
                      }}>+91</span>
                      <input
                        type="tel"
                        id="mobile"
                        value={mobileNumber}
                        onChange={(e) => setMobileNumber(e.target.value.replace(/\D/g, ''))}
                        placeholder="Enter 10-digit mobile number"
                        maxLength="10"
                        style={{
                          flex: 1,
                          padding: '0.875rem 0',
                          border: 'none',
                          outline: 'none',
                          backgroundColor: 'transparent',
                          fontSize: '1rem',
                          color: '#1e293b'
                        }}
                        required
                      />
                    </div>
                  </div>

                  <button 
                    type="submit" 
                    style={{
                      width: '100%',
                      padding: '0.875rem',
                      backgroundColor: '#3b82f6',
                      color: 'white',
                      border: 'none',
                      borderRadius: '12px',
                      fontSize: '1rem',
                      fontWeight: '600',
                      cursor: 'pointer',
                      transition: 'all 0.3s ease',
                      boxShadow: '0 4px 6px -1px rgba(59, 130, 246, 0.3), 0 2px 4px -1px rgba(59, 130, 246, 0.1)',
                      ':hover': {
                        backgroundColor: '#2563eb',
                        transform: 'translateY(-1px)'
                      },
                      ':active': {
                        transform: 'translateY(0)'
                      },
                      ':disabled': {
                        opacity: 0.7,
                        cursor: 'not-allowed',
                        transform: 'none'
                      }
                    }}
                    disabled={isLoading}
                  >
                    {isLoading ? (
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <svg 
                          style={{ 
                            animation: 'spin 1s linear infinite',
                            marginRight: '0.5rem',
                            width: '1.25rem',
                            height: '1.25rem'
                          }} 
                          xmlns="http://www.w3.org/2000/svg" 
                          fill="none" 
                          viewBox="0 0 24 24"
                        >
                          <circle style={{ opacity: 0.25 }} cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                          <path style={{ opacity: 0.75 }} fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                        </svg>
                        Verifying...
                      </div>
                    ) : (
                      'Continue to Portal'
                    )}
                  </button>

                  {error && (
                    <div style={{
                      marginTop: '1.25rem',
                      padding: '0.875rem',
                      backgroundColor: '#fee2e2',
                      color: '#b91c1c',
                      borderRadius: '8px',
                      textAlign: 'center',
                      fontSize: '0.875rem',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}>
                      <svg 
                        xmlns="http://www.w3.org/2000/svg" 
                        width="16" 
                        height="16" 
                        viewBox="0 0 24 24" 
                        fill="none" 
                        stroke="currentColor" 
                        strokeWidth="2" 
                        strokeLinecap="round" 
                        strokeLinejoin="round"
                        style={{ marginRight: '0.5rem' }}
                      >
                        <circle cx="12" cy="12" r="10"></circle>
                        <line x1="12" y1="8" x2="12" y2="12"></line>
                        <line x1="12" y1="16" x2="12.01" y2="16"></line>
                      </svg>
                      {error}
                    </div>
                  )}
                </form>
              </div>
            </div>
          ) : (
            <>
              <div style={cardStyle}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <div>
                    <h2 style={{ fontSize: '1.25rem', fontWeight: '600', marginBottom: '0.25rem' }}>
                      Welcome, {parentData?.name || 'Parent'}
                    </h2>
                    <p style={{ color: '#64748b' }}>Mobile: {parentData?.mobile}</p>
                  </div>
                  <button
                    onClick={() => {
                      setMobileVerified(false);
                      setMobileNumber('');
                      setParentData(null);
                      setSelectedClass('');
                    }}
                    style={{
                      backgroundColor: '#ef4444',
                      color: 'white',
                      padding: '0.5rem 1rem',
                      border: 'none',
                      borderRadius: '8px',
                      cursor: 'pointer'
                    }}
                  >
                    Logout
                  </button>
                </div>
              </div>

              <div style={cardStyle}>
                <h2 style={{ fontSize: '1.25rem', fontWeight: '600', marginBottom: '1rem' }}>Select Your Class</h2>
                <select
                  style={inputStyle}
                  value={selectedClass}
                  onChange={(e) => setSelectedClass(e.target.value)}
                >
                  <option value="">Select a class...</option>
                  {classes.map(cls => (
                    <option key={cls.id} value={cls.id}>{cls.name}</option>
                  ))}
                </select>
              </div>

              {/* <div style={tabStyle}>
                {selectedClass && (
                  <>
                    <button 
                      style={tabButtonStyle(true)}
                    >
                      Yearly Plan
                    </button>
                    <button 
                      style={tabButtonStyle(false)}
                    >
                      Academic Resources
                    </button>
                    <button 
                      style={tabButtonStyle(false)}
                    >
                      Exam Information
                    </button>
                  </>
                )}
              </div> */}

              <div>
                <div style={cardStyle}>
                  <h2 style={{ fontSize: '1.25rem', fontWeight: '600', marginBottom: '1rem' }}>Yearly Academic Plans</h2>
                  {yearlyPlans.length > 0 ? (
                    yearlyPlans.map((plan, index) => (
                      <div key={index} style={fileItemStyle}>
                        <svg style={{ width: '1.5rem', height: '1.5rem', color: '#3b82f6', marginRight: '1rem' }} fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm2 6a1 1 0 011-1h6a1 1 0 110 2H7a1 1 0 01-1-1zm1 3a1 1 0 100 2h6a1 1 0 100-2H7z" clipRule="evenodd" />
                        </svg>
                        <div style={{ flex: 1 }}>
                          <div style={{ fontWeight: '500' }}>Academic Year {plan.year || 'N/A'}</div>
                          <div style={{ fontSize: '0.875rem', color: '#64748b' }}>{plan.fileName || 'Yearly Plan Document'}</div>
                        </div>
                        {plan.fileUrl ? (
                          <a 
                            href={plan.fileUrl} 
                            target="_blank" 
                            rel="noopener noreferrer"
                            style={{
                              padding: '0.5rem 1rem',
                              backgroundColor: '#3b82f6',
                              color: 'white',
                              borderRadius: '8px',
                              textDecoration: 'none',
                              fontSize: '0.875rem',
                              fontWeight: '500'
                            }}
                          >
                            Download
                          </a>
                        ) : (
                          <span style={{ color: '#64748b', fontSize: '0.875rem' }}>No file available</span>
                        )}
                      </div>
                    ))
                  ) : (
                    <p style={{ color: '#64748b' }}>No yearly plans available for this class.</p>
                  )}
                </div>
              </div>

              <div>
                <div style={cardStyle}>
                  <h2 style={{ fontSize: '1.25rem', fontWeight: '600', marginBottom: '1rem' }}>Class Syllabus</h2>
                  {syllabus.length > 0 ? (
                    syllabus.map((syl, index) => (
                      <div key={index} style={fileItemStyle}>
                        <svg style={{ width: '1.5rem', height: '1.5rem', color: '#10b981', marginRight: '1rem' }} fill="currentColor" viewBox="0 0 20 20">
                          <path d="M9 4.804A7.968 7.968 0 005.5 4c-1.255 0-2.443.29-3.5.804v10A7.969 7.969 0 015.5 14c1.669 0 3.218.51 4.5 1.385A7.962 7.962 0 0114.5 14c1.255 0 2.443.29 3.5.804v-10A7.968 7.968 0 0014.5 4c-1.255 0-2.443.29-3.5.804V12a1 1 0 11-2 0V4.804z" />
                        </svg>
                        <div style={{ flex: 1 }}>
                          <div style={{ fontWeight: '500' }}>{syl.fileName}</div>
                          <div style={{ fontSize: '0.875rem', color: '#64748b' }}>
                            Uploaded on {moment(syl.uploadedAt).format('MMMM D, YYYY')}
                          </div>
                        </div>
                        <a 
                          href={syl.fileUrl} 
                          target="_blank" 
                          rel="noopener noreferrer"
                          style={{
                            padding: '0.5rem 1rem',
                            backgroundColor: '#10b981',
                            color: 'white',
                            borderRadius: '8px',
                            textDecoration: 'none',
                            fontSize: '0.875rem',
                            fontWeight: '500'
                          }}
                        >
                          Download
                        </a>
                      </div>
                    ))
                  ) : (
                    <p style={{ color: '#64748b' }}>No syllabus available for this class.</p>
                  )}
                </div>
              </div>

              <div>
                <div style={cardStyle}>
                  <h2 style={{ fontSize: '1.25rem', fontWeight: '600', marginBottom: '1rem' }}>Exam Timetables</h2>
                  {examTimetables.length > 0 ? (
                    examTimetables.map((timetable, index) => (
                      <div key={index} style={fileItemStyle}>
                        <svg style={{ width: '1.5rem', height: '1.5rem', color: '#7c3aed', marginRight: '1rem' }} fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clipRule="evenodd" />
                        </svg>
                        <div style={{ flex: 1 }}>
                          <div style={{ fontWeight: '500' }}>{timetable.examName || 'Exam Timetable'}</div>
                          <div style={{ fontSize: '0.875rem', color: '#64748b' }}>{timetable.fileName}</div>
                        </div>
                        <a 
                          href={timetable.fileUrl} 
                          target="_blank" 
                          rel="noopener noreferrer"
                          style={{
                            padding: '0.5rem 1rem',
                            backgroundColor: '#7c3aed',
                            color: 'white',
                            borderRadius: '8px',
                            textDecoration: 'none',
                            fontSize: '0.875rem',
                            fontWeight: '500'
                          }}
                        >
                          Download
                        </a>
                      </div>
                    ))
                  ) : (
                    <p style={{ color: '#64748b' }}>No exam timetables available for this class.</p>
                  )}
                </div>
              </div>
            </>
          )}
        </main>
      </div>
      <Footer/>
    </>
  );
};

export default SchoolInformationPage;